import bondWaiverGrid from './bond-waiver-grid';
import bondWaiverRequestForm from './bond-waiver-request'

export default function(nameAction, namePage){
  if(nameAction === 'requestgrid') {
    //console.log('call bonWaiverGrid');
    bondWaiverGrid();
  }
  if(nameAction === 'requestform'){
    bondWaiverRequestForm();
  }
}